import { Container, Row, Col, Media } from 'react-bootstrap'
import { LEProgress } from '@components/Block'
import Link from 'next/link'

export default function NewRewardUpdate(){
    return(
        <div className="new-reward-update py-5">
            <Container className=" py-3">
                <Row>
                    <Col lg={8}>
                    <Media>
                        <img src="/images/learnandearn/img-new-reward.svg" className="mr-4"/>
                        <Media.Body>
                            <h4 className="font-weight-bold">New Reward Update</h4>
                            <p className="mr-5">
                            Your wellness guide Adam is offering you a new reward! <br/>
                            If you earn 30 more wellness IQ points before the end of June you’ll 
                            earn a free soap dispenser
                            </p>

                            <Media className="pt-2 mb-4 align-items-center">
                                <img src="/images/learnandearn/img-hand-dispenser.jpg" />
                                <Media.Body>
                                    <p>This super handy cute dispenser is great and shiny. <br/>  You can <Link href=""><a className="text-green"><u>learn more here</u></a></Link>.  </p>
                                </Media.Body>
                            </Media>
                        </Media.Body>
                        </Media>
                    </Col>
                    <Col lg={4}>
                        <LEProgress/>
                    </Col>
                </Row>
            </Container>
            <hr className="divider mx-auto "/>
           <style jsx global>
               {`
                .progress{
                    height: 1rem;
                    background-color: #d5d8da;
                }
                .divider{
                    max-width:1439px;
                }
               `}
           </style>
        </div>
    )
}